<template>
  <div
    class="
      tw-rounded
      tw-w-full
      tw-h-20
      tw-flex
      tw-items-center
      tw-justify-center
      tw-py-4
    "
    :class="wrapperClass"
  >
    <div
      class="
        tw-w-7
        tw-h-7
        tw-bg-sf-neutral-subtle-2
        tw-rounded
        tw-flex
        tw-justify-center
        tw-items-center
      "
    >
      <span class="tw-text-base" :class="[iconClass, icon]" />
    </div>
    <div class="tw-w-4/5 tw-px-2">
      <div class="tw-text-sm tw-font-medium">
        {{ label }}
      </div>
      <div class="tw-text-xs">
        {{ description }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  selected: Boolean,
  label: String,
  description: String,
  icon: String,
})

const wrapperClass = computed(() => {
  return {
    'tw-bg-sf-snow-lighter tw-border-solid tw-border tw-border-sf-primary-dark':
      props.selected,
    'tw-text-sf-dark-dark hover:tw-cursor-pointer': !props.selected,
  }
})

const iconClass = computed(() => {
  return { 'tw-text-sf-primary': props.selected }
})
</script>
